// Both default to ON, so the env vars can be left out; only an explicit 'false' rolls back to the
// old pages. USE_NEW_UI used `=== 'true'`, so a stray character after the quoted value in the prod
// env secret kept the quotes in the value and shipped the old UI.
const USE_NEW_UI = process.env.REACT_APP_USE_NEW_UI !== 'false'
const USE_NEW_STAFF_FORM = process.env.REACT_APP_USE_NEW_STAFF_FORM !== 'false'
// Defaults to ON when unset. Only the devweb2 comparison build sets it to 'false'
// to serve the pre-redesign booking page (CamperDetailOld) next to the new one.
const USE_NEW_BOOKING_PAGE = process.env.REACT_APP_USE_NEW_BOOKING_PAGE !== 'false'
// Director Reporting tab (docs/director-reporting-prototype.md). Defaults to ON like the two above; only
// an explicit 'false' removes the /reports route and the Reports nav item.
const USE_REPORTING_TAB = process.env.REACT_APP_USE_REPORTING_TAB !== 'false'
const lsCampCode_ = process.env.REACT_APP_lsCampCode_
const giftcardRsaPublicKey = process.env.REACT_APP_GIFTCARD_RSA_PUBLIC_KEY
const donationRsaPublicKey = process.env.REACT_APP_DONATION_RSA_PUBLIC_KEY
const mode= process.env.REACT_APP_mode
const viClientId= process.env.REACT_APP_viClientId
const mySecretKey= process.env.REACT_APP_mySecretKey
const url= process.env.REACT_APP_url
const socketurl= process.env.REACT_APP_socketurl
const AUTH= process.env.REACT_APP_AUTH
const GOOGLE_KEY= process.env.REACT_APP_GOOGLE_KEY
const SITE_URL= process.env.REACT_APP_SITE_URL
const districtCamp= process.env.REACT_APP_districtCamp
const sportInternationalCamp= process.env.REACT_APP_sportInternationalCamp
const gogleTagManagerUrl=process.env.REACT_APP_gogleTagManagerUrl
const ga4CampCode=process.env.REACT_APP_SI_GA4_CAMP_CODE
const ga4MeasurementId=process.env.REACT_APP_SI_GA4_MEASUREMENT_ID
const searchDebounceDelay = Number(process.env.REACT_APP_SEARCH_DEBOUNCE_DELAY) || 3000



export const development = {
    USE_NEW_UI,
    USE_NEW_STAFF_FORM,
    USE_NEW_BOOKING_PAGE,
    USE_REPORTING_TAB,
    lsCampCode_,
    searchDebounceDelay,
    api: {
        mode, viClientId, mySecretKey, url,
        socketurl, AUTH, GOOGLE_KEY, SITE_URL, districtCamp,
        sportInternationalCamp, gogleTagManagerUrl, ga4CampCode, ga4MeasurementId,
        giftcardRsaPublicKey,
        donationRsaPublicKey,
    }

}

export const local = {
    USE_NEW_UI,
    USE_NEW_STAFF_FORM,
    USE_NEW_BOOKING_PAGE,
    USE_REPORTING_TAB,
    lsCampCode_,
    searchDebounceDelay,
    api: {
        mode, viClientId, mySecretKey, url,
        socketurl, AUTH, GOOGLE_KEY, SITE_URL, districtCamp,
        sportInternationalCamp, gogleTagManagerUrl, ga4CampCode, ga4MeasurementId,
        giftcardRsaPublicKey,
        donationRsaPublicKey,
    }
}

export const prod = {
    USE_NEW_UI,
    USE_NEW_STAFF_FORM,
    USE_NEW_BOOKING_PAGE,
    USE_REPORTING_TAB,
    lsCampCode_,
    searchDebounceDelay,
    api: {
        mode, viClientId, mySecretKey, url,
        socketurl, AUTH, GOOGLE_KEY, SITE_URL, districtCamp,
        sportInternationalCamp, gogleTagManagerUrl, ga4CampCode, ga4MeasurementId,
        giftcardRsaPublicKey,
        donationRsaPublicKey,
    }
}